function pad(n) {
  return n < 10 ? "0" + n : String(n);
}

function ymd(date) {
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate())
  );
}

function parseYmd(str) {
  const p = String(str).split("-").map(Number);
  return new Date(p[0], p[1] - 1, p[2]);
}

function addDays(date, days) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  d.setDate(d.getDate() + days);
  return d;
}

function inWindow(now, center, before, after) {
  const c = typeof center === "string" ? parseYmd(center) : center;
  const t = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const start = addDays(c, -before);
  const end = addDays(c, after);
  return t.getTime() >= start.getTime() && t.getTime() <= end.getTime();
}

/** 农历春节（正月初一）公历日 */
const SPRING_FESTIVAL = [
  "2023-01-22",
  "2024-02-10",
  "2025-01-29",
  "2026-02-17",
  "2027-02-06",
  "2028-01-26",
  "2029-02-13",
  "2030-02-03",
  "2031-01-23",
  "2032-02-11",
  "2033-01-31",
  "2034-02-19",
  "2035-02-08",
  "2036-01-28",
];

const QINGMING = [
  "2023-04-05",
  "2024-04-04",
  "2025-04-04",
  "2026-04-05",
  "2027-04-05",
  "2028-04-04",
  "2029-04-04",
  "2030-04-05",
  "2031-04-05",
  "2032-04-04",
  "2033-04-05",
  "2034-04-05",
  "2035-04-05",
  "2036-04-04",
];

const DUANWU = [
  "2023-06-22",
  "2024-06-10",
  "2025-05-31",
  "2026-06-19",
  "2027-06-09",
  "2028-05-28",
  "2029-06-16",
  "2030-06-05",
  "2031-06-14",
  "2032-06-12",
  "2033-06-01",
  "2034-06-20",
  "2035-06-10",
  "2036-05-30",
];

const QIXI = [
  "2023-08-22",
  "2024-08-10",
  "2025-08-29",
  "2026-08-19",
  "2027-08-08",
  "2028-08-26",
  "2029-08-16",
  "2030-08-04",
  "2031-08-23",
  "2032-08-11",
  "2033-08-30",
  "2034-08-19",
  "2035-08-09",
  "2036-08-27",
];

const ZHONGYUAN = [
  "2023-08-30",
  "2024-08-18",
  "2025-09-06",
  "2026-08-27",
  "2027-08-16",
  "2028-09-03",
  "2029-08-23",
  "2030-08-13",
  "2031-09-01",
  "2032-08-20",
  "2033-09-08",
  "2034-08-28",
  "2035-08-17",
  "2036-09-04",
];

const CHONGYANG = [
  "2023-10-23",
  "2024-10-11",
  "2025-10-29",
  "2026-10-18",
  "2027-10-08",
  "2028-10-26",
  "2029-10-16",
  "2030-10-05",
  "2031-10-24",
  "2032-10-12",
  "2033-10-01",
  "2034-10-20",
  "2035-10-09",
  "2036-10-27",
];

const ZHONGQIU = [
  "2023-09-29",
  "2024-09-17",
  "2025-10-06",
  "2026-09-25",
  "2027-09-15",
  "2028-10-03",
  "2029-09-22",
  "2030-09-12",
  "2031-10-01",
  "2032-09-19",
  "2033-09-08",
  "2034-09-27",
  "2035-09-16",
  "2036-10-04",
];

const LABA = [
  "2023-12-30",
  "2024-01-18",
  "2025-01-07",
  "2026-01-26",
  "2027-01-15",
  "2028-01-04",
  "2029-01-22",
  "2030-01-12",
  "2031-01-01",
  "2031-12-21",
  "2032-01-20",
  "2033-01-08",
  "2033-12-28",
  "2034-01-16",
  "2035-01-06",
  "2035-12-26",
  "2036-01-15",
];

const XIAONIAN = [
  "2023-02-14",
  "2024-02-02",
  "2025-01-22",
  "2026-02-10",
  "2027-01-30",
  "2028-01-20",
  "2029-02-07",
  "2030-01-27",
  "2031-01-16",
  "2032-02-04",
  "2033-01-25",
  "2034-02-13",
  "2035-02-02",
  "2036-01-22",
];

function anyMatch(now, list, before, after) {
  return list.some((day) => inWindow(now, day, before, after));
}

export const FESTIVAL_LABELS = {
  chunjie: "春节快乐",
  xiaonian: "小年快乐",
  yuanxiao: "元宵节快乐",
  qingming: "清明节快乐",
  duanwu: "端午节快乐",
  qixi: "七夕节快乐",
  zhongyuan: "中元节快乐",
  chongyang: "重阳节快乐",
  laba: "腊八节快乐",
  zhongqiu: "中秋节快乐",
  guoqing: "国庆节快乐",
};

/**
 * 根据网络/本地日期判断当前节日（同一天优先春节）。
 */
export function detectFestival(now) {
  if (!(now instanceof Date) || Number.isNaN(now.getTime())) {
    return "";
  }
  if (anyMatch(now, SPRING_FESTIVAL, 1, 5)) {
    return "chunjie";
  }
  if (anyMatch(now, XIAONIAN, 1, 1)) {
    return "xiaonian";
  }
  const yuanxiao = SPRING_FESTIVAL.map((d) => ymd(addDays(parseYmd(d), 14)));
  if (anyMatch(now, yuanxiao, 1, 1)) {
    return "yuanxiao";
  }
  if (anyMatch(now, QINGMING, 1, 1)) {
    return "qingming";
  }
  if (anyMatch(now, DUANWU, 1, 1)) {
    return "duanwu";
  }
  if (anyMatch(now, QIXI, 1, 1)) {
    return "qixi";
  }
  if (anyMatch(now, ZHONGYUAN, 1, 1)) {
    return "zhongyuan";
  }
  const m = now.getMonth() + 1;
  const d = now.getDate();
  if (m === 10 && d >= 1 && d <= 7) {
    return "guoqing";
  }
  if (anyMatch(now, ZHONGQIU, 1, 1)) {
    return "zhongqiu";
  }
  if (anyMatch(now, CHONGYANG, 1, 1)) {
    return "chongyang";
  }
  if (anyMatch(now, LABA, 1, 1)) {
    return "laba";
  }
  return "";
}

export async function fetchNetworkNow() {
  const tryDateHeader = async (url) => {
    const res = await fetch(url, { method: "GET", cache: "no-store" });
    const hdr = res.headers.get("Date") || res.headers.get("date");
    if (hdr) {
      const d = new Date(hdr);
      if (!Number.isNaN(d.getTime())) {
        return d;
      }
    }
    return null;
  };
  const base =
    (typeof process !== "undefined" && process.env && process.env.BASE_URL) ||
    "/";
  const prefix = String(base).endsWith("/") ? base : `${base}/`;
  const urls = [
    `${prefix}version.json?_=${Date.now()}`,
    `${window.location.origin}${window.location.pathname || "/"}`,
  ];
  for (let i = 0; i < urls.length; i++) {
    try {
      const d = await tryDateHeader(urls[i]);
      if (d) {
        return d;
      }
    } catch (e) {
      /* next */
    }
  }
  try {
    const res = await fetch(
      "https://worldtimeapi.org/api/timezone/Asia/Shanghai",
      { cache: "no-store" }
    );
    if (res.ok) {
      const data = await res.json();
      const d = new Date(data.datetime || data.utc_datetime);
      if (!Number.isNaN(d.getTime())) {
        return d;
      }
    }
  } catch (e) {
    /* ignore */
  }
  return new Date();
}

export function runningAppVersion() {
  try {
    if (typeof __APP_BUILD_SIGNATURE__ !== "undefined" && __APP_BUILD_SIGNATURE__) {
      const sig = String(__APP_BUILD_SIGNATURE__);
      const v = sig.split("-")[0];
      if (v) {
        return v;
      }
    }
  } catch (e) {
    /* ignore */
  }
  return "";
}

export async function fetchAppVersion() {
  const fallback = runningAppVersion() || "";
  try {
    const base =
      (typeof process !== "undefined" && process.env && process.env.BASE_URL) ||
      "/";
    const prefix = String(base).endsWith("/") ? base : `${base}/`;
    const res = await fetch(`${prefix}version.json?_=${Date.now()}`, {
      cache: "no-store",
    });
    if (!res.ok) {
      return fallback;
    }
    const data = await res.json();
    return String((data && data.version) || fallback);
  } catch (e) {
    return fallback;
  }
}
